import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FooterComponent} from "./footer.component";
import {MatDividerModule} from '@angular/material/divider';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';


@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    MatDividerModule,
    RouterModule,
    MatButtonModule
  ],
  exports: [FooterComponent]
})
export class FooterModule {
}
